module.exports = __webpack_public_path__ + "img/4.e21626ef.jpg";